<template>
	<ul class="company-card__location-card-list">
		<div class="company-card__main-content">
			<div class="company-card__info">
				<span class="company-card__number">
					({{ company.companyNumber }})
				</span>
				<Ellipsis
					:data="company.companyName"
					:textToHighlight="search"
					class="company-card__name"
				></Ellipsis>
			</div>
			<Toggle
				v-model="company.activeBetaFeature"
				variant="condensed"
				@change="updateCompany"
			>
				<template slot="true-value">ON</template>
				<template slot="false-value">OFF</template>
			</Toggle>
		</div>
		<Divider
			class="company-card__divider"
			:variant="'horizontal-full-width'"
			v-if="!isLastCompany || (isLastCompany && totalLocations > 0)"
		/>
		<div
			v-if="totalLocations > 0"
			class="company-card__location-card-list-item"
		>
			<li
				v-for="(location, index) in company.locations"
				:key="`${location.id}_${index}`"
			>
				<LocationCard
					:location="location"
					:search="search"
					ref="locationCard"
					@location-updated="handleLocationUpdated($event)"
					:isLastLocation="
						isLastCompany && index === totalLocations - 1
					"
				/>
			</li>
		</div>
	</ul>
</template>

<script>
import LocationCard from './location-card';
import Ellipsis from '@/components/visual/ellipsis';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Divider from '@/components/shells/divider/divider';
// mixins
import AccordionStatus from '@/mixins/ccl-selector/accordions-status-mixin';
// utils
import { createTextValueObj } from '@/utils/object';
import _ from 'lodash';

export default {
	name: 'CompanyCard',
	components: {
		LocationCard,
		Ellipsis,
		Toggle,
		Divider
	},
	mixins: [AccordionStatus],
	props: {
		company: {
			type: Object,
			default: () => {}
		},
		search: {
			type: String,
			default: ''
		},
		isLastCompany: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		totalLocations() {
			return _.get(this, 'company.locations.length', 0);
		},
		displayCompanyName() {
			return createTextValueObj(this.company.companyName, this.search);
		}
	},
	methods: {
		updateCompany() {
			this.$emit('company-updated', this.company);
		},
		handleLocationUpdated(location) {
			if (!_.isEmpty(location) && !_.isEmpty(this.company.locations)) {
				const index = this.company.locations.findIndex(
					loc => loc.id === location.id
				);
				if (index !== -1) {
					this.$set(this.company.locations, index, location);
					this.$emit('company-updated', this.company);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-card {
	@include card('accordion');

	&__main-content {
		display: grid;
		grid-template-columns: 1fr auto;
		gap: $gutter-md;
	}
	&__info {
		display: flex;
		align-items: center;
		gap: $gutter-sm;
		font-size: $heading-font-size-sm;
		min-width: 100%;
	}
	&__divider {
		margin-top: $gutter-lg;
		margin-bottom: $gutter-lg;
	}

	&__name {
		text-transform: capitalize;
		word-break: break-all;
	}

	&__location-card-list {
		display: flex;
		flex-direction: column;
	}
}
</style>
